// Header.jsx
import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo-section">
          <h1 className="logo">Ankur Srivastava</h1>
          <span className="tagline">Finance Educator & Corporate Professional</span>
        </div>
        
        <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-list">
            <li className="nav-item">
              <button 
                className="nav-link" 
                onClick={() => scrollToSection('Profile')}
              >
                Profile
              </button>
            </li>
            <li className="nav-item">
              <button 
                className="nav-link" 
                onClick={() => scrollToSection('education')}
              >
                Education
              </button>
            </li>
            <li className="nav-item">
              <button 
                className="nav-link" 
                onClick={() => scrollToSection('experience')}
              >
                Experience
              </button>
            </li>
            <li className="nav-item">
              <button 
                className="nav-link" 
                onClick={() => scrollToSection('academics')}
              >
                Academic Portfolio
              </button>
            </li>

            <li className="nav-item">
              <button 
                className="nav-link" 
                onClick={() => scrollToSection('research')}
              >
                Research
              </button>
            </li>
            
            <li className="nav-item">
              <button 
                className="nav-link" 
                onClick={() => scrollToSection('contact')}
              >
                Contact
              </button>
            </li>
          </ul>
        </nav>

        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;